import { getLocalStorageByExpire } from "@/utils/utils";
import { useModel } from "@umijs/max";
import { useEffect, useState } from "react";

export default function AiAgent(props) {
  const [isChatbotVisible, setIsChatbotVisible] = useState(false);
  const [showAi, setShowAi] = useState(false);
  const { initialState } = useModel("@@initialState");
  // 切换聊天机器人显示/隐藏（类组件方法，绑定 this 上下文）
  const toggleChatbot = () => {
    setIsChatbotVisible(!isChatbotVisible);
  };
  //判断用户是否登录
  useEffect(() => {
    const sessionid = getLocalStorageByExpire("sessionid");
    const menuList = initialState.menuList;
    const hasPermission = menuList?.data?.some(
      (item) => item.name === "Ai客服"
    );

    if (sessionid && hasPermission) {
      setShowAi(true);
    } else {
      setShowAi(false);
    }
  }, [initialState]);
  const renderChatBox = () => {
    return (
      <div
        className="chatbot"
        style={{
          width: "60px",
          height: "60px",
          background: "url(/robot/chatbot.png) no-repeat",
          cursor: "pointer",
          position: "fixed",
          bottom: "-85vh",
          right: "20px",
          zIndex: 1000,
        }}
        onClick={toggleChatbot} // 调用类组件绑定好的方法
      />
    );
  };
  return (
    <>
      {showAi && renderChatBox()}
      {
        <div
          style={{
            position: "fixed",
            bottom: "-85vh",
            right: isChatbotVisible ? "20px" : "-1000px",
            width: "400px",
            height: "800px",
            zIndex: 10000,
            backgroundColor: "#fff",
            boxShadow: "0 0 10px rgba(0, 0, 0, 0.1)",
            borderRadius: "10px",
          }}
        >
          <div
            style={{
              width: "20px",
              height: "20px",
              background:
                "url(/map/image/preventWaterlog/closeBtn.png) no-repeat center center",
              position: "absolute",
              right: "10px",
              top: "10px",
              zIndex: 1000,
              borderRadius: "10px",
              backgroundColor: "black",
              cursor: "pointer",
            }}
            onClick={toggleChatbot}
          />
          <iframe
            src="https://ecloud.10086.cn/api/query/maas/public/console/agent-experience?accessCode=ZmFaeYmrMGJO"
            width="400px"
            height="100%"
            frameBorder="0"
            style={{ borderRadius: "10px" }}
            allow="microphone"
          />
        </div>
      }
    </>
  );
}
